export default function PageJsonLd() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'ContactPage',
        name: 'Контакты BusinessTraining.by',
        description: 'Свяжитесь с BusinessTraining.by для заказа корпоративного тренинга, обучения сотрудников, тренинга по продажам и переговорам. Минск, Беларусь, онлайн.',
        url: 'https://business-training.by/contacts',
        mainEntity: {
          '@type': 'Organization',
          name: 'BusinessTraining.by',
          url: 'https://business-training.by',
          contactPoint: [
            {
              '@type': 'ContactPoint',
              telephone: '+375255024478',
              contactType: 'sales',
              contactOption: 'Telegram',
              description: 'Telegram @a_sivko',
              url: 'https://t.me/a_sivko'
            },
            {
              '@type': 'ContactPoint',
              telephone: '+375255024478',
              contactType: 'sales',
              contactOption: 'TollFree',
              description: 'Телефон для связи'
            },
            {
              '@type': 'ContactPoint',
              email: 'info@business-training.by',
              contactType: 'sales',
              contactOption: 'Email',
              description: 'Email для запросов'
            }
          ]
        }
      },
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: 'Главная', item: { '@id': 'https://business-training.by/', name: 'Главная' } },
          { '@type': 'ListItem', position: 2, name: 'Контакты', item: { '@id': 'https://business-training.by/contacts', name: 'Контакты' } }
        ]
      },
      {
        '@type': 'Organization',
        name: 'BusinessTraining.by',
        url: 'https://business-training.by',
        description: 'Корпоративные тренинги и обучение сотрудников в Минске, Беларуси и онлайн.',
        address: {
          '@type': 'PostalAddress',
          addressLocality: 'Минск',
          addressCountry: 'BY'
        },
        areaServed: ['BY', 'RU', 'KZ', 'IL'],
        contactPoint: {
          '@type': 'ContactPoint',
          telephone: '+375255024478',
          contactType: 'sales'
        },
        founder: {
          '@type': 'Person',
          name: 'Алексей Сивко',
          jobTitle: 'Бизнес-тренер, консультант, фасилитатор',
          description: 'Практикующий бизнес-тренер с более чем 18-летним опытом в корпоративных продажах и переговорах. 100+ корпоративных проектов.',
          url: 'https://business-training.by/o-trenere',
          sameAs: ['https://t.me/a_sivko']
        }
      },
      {
        '@type': 'FAQPage',
        mainEntity: [
          {
            '@type': 'Question',
            name: 'Сколько времени ждать ответа от BusinessTraining.by?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Обычно отвечаем в течение одного рабочего дня. В срочных случаях — в течение нескольких часов. Все заявки обрабатываются лично.'
            }
          },
          {
            '@type': 'Question',
            name: 'Можно ли провести предварительную встречу перед заказом тренинга?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Да, перед началом любого проекта проводится онлайн- или офлайн-встреча для понимания задач бизнеса, анализа текущей ситуации и определения целей обучения.'
            }
          },
          {
            '@type': 'Question',
            name: 'Можно ли провести корпоративное обучение в другом городе?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Да, работаем по всей Беларуси, также проводим проекты в России, Казахстане, Узбекистане, Израиле и онлайн по всему миру.'
            }
          },
          {
            '@type': 'Question',
            name: 'Можно ли заказать только консультацию без обязательства заказывать обучение?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Да, можно провести консультацию для обсуждения задачи без обязательства заказывать обучение. Это поможет понять масштаб проблемы и возможные пути решения.'
            }
          },
          {
            '@type': 'Question',
            name: 'Можно ли провести обучение онлайн?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Да, многие программы успешно проходят полностью дистанционно. Онлайн-формат включает интерактивные инструменты, разбор реальных кейсов, ролевые игры и практические задания. Эффективность не уступает очному обучению.'
            }
          },
          {
            '@type': 'Question',
            name: 'Как быстро готовится программа обучения после обращения?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'После первичной консультации и диагностики программа готовится в течение 3-7 рабочих дней в зависимости от сложности. Индивидуальная программа создаётся под конкретный бизнес, отрасль и цели компании.'
            }
          }
        ]
      }
    ]
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
}